import React from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';
import SectionHeader from '@marketing/components/section_header';
import UnderlinedText from '@marketing/components/underlined_text';

import ChrisHeadshot from './assets/chris_headshot.png';
import ElliotHeadshot from './assets/elliot_headshot.png';
import KatHeadshot from './assets/kat_headshot.png';
import KristinHeadshot from './assets/kristin_headshot.png';
import LinneaHeadshot from './assets/linnea_headshot.png';
import MikeHeadshot from './assets/mike_headshot.png';
import StarIcon from './assets/star_icon.svg';
import colors from '@magoosh/lib/styles/colors.module.scss';
import styles from './style.module.scss';

export default (props) => {
  return (
    <div className="d-flex flex-column gap-l" style={{ position: 'relative' }}>
      <SectionHeader
        subtitle="Learn from teachers who know the ACT inside and out."
        supertitle="Expert teachers"
        supertitleIcon={StarIcon}
        title={<>Our instructors are test prep <UnderlinedText color={colors.brandSecondary}>experts</UnderlinedText></>}
      />

      <div className="d-flex flex-column flex-lg-row flex-lg-wrap gap-m">
        <InstructorCard
          avatar={LinneaHeadshot}
          name="Linnea Newman"
        >
          Linnea is an authority in the test prep field. She has over 15 years experience coaching students through various aspects of the admissions process, working with students of all ages and abilities.
        </InstructorCard>

        <InstructorCard
          avatar={MikeHeadshot}
          name="Mike McGarry"
        >
          Mike McGarry has a BS and an MA from Harvard. He also has more than 20 years of teaching experience specializing in math, science and standardized exams.
        </InstructorCard>

        <InstructorCard
          avatar={KristinHeadshot}
          name="Kristin Fracchia"
        >
          Kristin Fracchia has a PhD from UC Irvine and degrees in Education and English. She’s been helping students prepare for standardized tests for over 8 years.
        </InstructorCard>

        <InstructorCard
          avatar={KatHeadshot}
          name="Kat Thomson"
        >
          Kat Thomson has a BA in psychophysiology and PhD in medical sociology from UCSF. Since 2005, she's been teaching premed at colleges across the U.S.
        </InstructorCard>

        <InstructorCard
          avatar={ChrisHeadshot}
          name="Chris Lele"
        >
          Chris Lele is a UCLA graduate with more than 10 years of experience tutoring math and verbal for the ACT. He has coached many students to perfect scores.
        </InstructorCard>

        <InstructorCard
          avatar={ElliotHeadshot}
          name="Elliot Hirsen"
        >
          Elliot has logged over 5,000 hours in 1-on-1 test prep sessions, and has posted 99% scores on the GMAT, GRE, and LSAT.
        </InstructorCard>
      </div>
    </div>
  );
};

interface InstructorCardProps {
  avatar: string;
  children: any;
  name: string;
}

const InstructorCard = (props: InstructorCardProps) => {
  return (
    <Card
      className={cx(styles.instructorCard, 'd-flex flex-column gap-m')}
    >
      <div className="align-items-center d-flex flex-row gap-s">
        <div>
          <img alt={`Image of ${props.name}`} height="56px" loading="lazy" src={props.avatar} width="56px" />
        </div>

        <div className="text-inter"><strong>{props.name}</strong></div>
      </div>

      <div className="text-inter text-medium">
        {props.children}
      </div>
    </Card>
  );
};
